/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionNotificationConfiguration {
    getFixupPrototypeFunction() { return ScheduleExecutionNotificationConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionNotificationConfiguration>): ScheduleExecutionNotificationConfiguration {
        let obj = Object.assign(new ScheduleExecutionNotificationConfiguration(), model);
        ScheduleExecutionNotificationConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionNotificationConfiguration>): ScheduleExecutionNotificationConfiguration {
        if (!model) return null;
        return ScheduleExecutionNotificationConfiguration.newInstance(<ScheduleExecutionNotificationConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionNotificationConfiguration) {
        if (!obj) return;

        models.ScheduleExecutionNotificationConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionNotificationConfiguration): boolean {
        Object.setPrototypeOf(obj, ScheduleExecutionNotificationConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.webhooks) {
            for (let val of this.webhooks) {
                models.ScheduleExecutionNotificationWebHookForStandardType.fixupPrototype(val);
            }
        }
        if (this.microsoft_teams_webhooks) {
            for (let val of this.microsoft_teams_webhooks) {
                models.ScheduleExecutionNotificationForTeamsWebHook.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Email IDs
     */
    email_recipients: Array<string>;

    /**
     * Webhooks to trigger notifications
     */
    webhooks: Array<models.ScheduleExecutionNotificationWebHookForStandardType>;

    /**
     * Teams webhooks to trigger notifications
     */
    microsoft_teams_webhooks: Array<models.ScheduleExecutionNotificationForTeamsWebHook>;

}
